export enum ReservationState {
  New = "New",
  ReadyForPickUp = "ReadyForPickUp",
  PackagingReadyForPickUp = "PackagingReadyForPickUp",
  Completed = "Completed",
  Canceled = "Canceled",
}
